import { check_objects_are_the_same } from "../lib/helpers";
import { setFlash } from "./flash";

export function useWeeklyMenu() {
  function WeeklyMenu(menu) {
    if (!(menu instanceof Element)) {
      return;
    }

    // Get all .weekly-menu__item
    const menu_items = menu.querySelectorAll(".weekly-menu__item");
    // // Background overlay
    // const overlay = menu.querySelector(".overlay-click-off");

    function get_item_elements(item) {
      // Button that opens the item selection pop up
      const button_open = item.querySelector(".btn-add");
      // Button that confirms/updates item in order
      const button_confirm = item.querySelector(".btn-confirm");
      // Button that cancels/removes item from order
      const button_cancel = item.querySelector(".btn-cancel");
      // Button that cancels changes
      const button_revert = item.querySelector(".btn-revert");

      // Size selection radio buttons
      const size_radios = item.querySelectorAll(
        ".weekly-menu__options--sizing input[type='radio']"
      );
      // Meal portion Size selection select field
      const size_selects = item.querySelectorAll(
        ".weekly-menu__options--sizing select"
      );

      // Add on quantities
      const add_on_inputs = item.querySelectorAll(
        ".weekly-menu__options--add-ons input"
      );
      // Fulfillment radios
      const fulfillment_radios = item.querySelectorAll(
        ".weekly-menu__options--fulfillment input"
      );

      // Error message flash
      const error_flash = item.querySelector(".flash-warning");
      // Click to close
      const click_to_close = item.querySelector(".overlay-click-off");

      return {
        button_open,
        button_confirm,
        button_cancel,
        button_revert,
        size_radios,
        size_selects,
        add_on_inputs,
        fulfillment_radios,
        error_flash,
        click_to_close,
      };
    }

    // Open item selection pop up
    function open_selection_pop_up(item) {
      // Select pop up
      const menu_options = item.querySelector(".weekly-menu__options");
      // Get item elements
      const { click_to_close } = get_item_elements(item);

      // Apply open classes
      item.classList.add("open");
      menu_options.classList.add("open");
      click_to_close.classList.add("open");
    }

    function close_selection_pop_up(
      item,
      flash = { msg: "Order not updated", type: "warning" }
    ) {
      // Select pop up
      const menu_options = item.querySelector(".weekly-menu__options");
      // Get item elements
      const { click_to_close } = get_item_elements(item);

      // Apply close classes
      item.classList.remove("open");
      menu_options.classList.remove("open");
      click_to_close.classList.remove("open");
      setFlash(flash.msg, flash.type, flash.time);
    }

    // Control internal options flash message
    function set_internal_flash(
      item,
      msg = "You must select a size!",
      time = 2000
    ) {
      // Get item elements
      const { error_flash } = get_item_elements(item);

      error_flash.textContent = msg;
      error_flash.classList.add("active");
      setTimeout(() => {
        error_flash.classList.remove("active");
      }, time);
    }

    // checks all inputs in item and returns array
    // of objects with basic input data
    function get_input_states(item) {
      // Get item elements
      const { add_on_inputs, size_radios,size_selects, fulfillment_radios } =
        get_item_elements(item);

      const input_state = [];

      [...size_radios, ...size_selects, ...add_on_inputs, ...fulfillment_radios].forEach(
        (input) => {
          const { id, value, checked } = input;

          input_state.push({
            id,
            value,
            checked,
          });
        }
      );

      return input_state;
    }

    function compare_state(item, starting_state) {
      // get current input states
      const current_state = get_input_states(item);

      // compare starting_state with current_state
      let input_has_been_changed = false;
      current_state.forEach((input, i) => {
        if (!check_objects_are_the_same(input, starting_state[i])) {
          input_has_been_changed = true;
        }
      });

      return input_has_been_changed;
    }

    // Confirm Add Item to Order
    function add_item_to_order(item) {
      // Get item elements
      const {
        button_open,
        button_confirm,
        button_cancel,
        button_revert,
        size_radios,
        size_selects,
        fulfillment_radios,
      } = get_item_elements(item);

      // - check a size has been selected
      /*let size_has_been_selected = false;

      size_radios.forEach((radio) => {
        if (radio.checked) {
          size_has_been_selected = true;
        }
      });
      // - - If not, set flash and return
      if (!size_has_been_selected) {
        set_internal_flash(item);
        return;
      }*/

      // - check a meal portion size has been selected
      let meal_size_has_been_selected = false;

      size_selects.forEach((select) => {
        if (select.value !== "None") {
          meal_size_has_been_selected = true;
        }
      });
      // - - If not, set flash and return
      if (!meal_size_has_been_selected) {
        set_internal_flash(item);
        return;
      }

      // Check if fulfillment has been selected
      let fulfillment_selected = false;
      fulfillment_radios.forEach((radio) => {
        if (radio.checked) {
          fulfillment_selected = true;
        }
      });
      // - - If not, set flash and return
      if (!fulfillment_selected) {
        set_internal_flash(item, "You must select Pick-Up or Delivery!");
        return;
      }

      // Check if it is a new order addition or an order update
      const adding_new_item = button_open.textContent.trim() === "Add to Order";
      // Dynamically set flash message
      const flash_msg = adding_new_item
        ? "Item added to order! Complete order by submitting below."
        : "Item order has been updated! Complete order by submitting below.";
      // - change main "Add To Order" button to "Added to Order!" and change color green
      button_open.textContent = "Added to Order!";
      button_open.classList.add("btn__green");
      // - change inner "Add to Order" button to "Update Order"
      button_confirm.textContent = "Update Order";
      // - change "Cancel" button to "Remove Order"
      button_cancel.textContent = "Remove Order";
      // mark item as added to order
      item.classList.add("item-in-order");
      // - reveal revert button
      button_revert.classList.remove("hidden");
      // - close pop up
      close_selection_pop_up(item, {
        msg: flash_msg,
        type: "success",
        time: 4000,
      });
    }

    // Cancel Add Item to Order
    function cancel_add_to_order(item) {
      // Get item elements
      const {
        button_open,
        button_confirm,
        button_cancel,
        button_revert,
        add_on_inputs,
        size_radios,
        size_selects,
        fulfillment_radios,
      } = get_item_elements(item);
      // - change main "Added to Order!" button to "Add To Order" and change color to yellow
      button_open.textContent = "Add to Order";
      button_open.classList.remove("btn__green");
      // - change inner "Update Order" button to "Add to Order"
      button_confirm.textContent = "Add to Order";
      // - change "Remove Order" button to "Cancel"
      button_cancel.textContent = "Cancel";
      // - hide revert button
      button_revert.classList.add("hidden");
      // - clear size selection
      size_radios.forEach((radio) => {
        radio.checked = false;
      });
      size_selects.forEach((select) => {
        select.value = "None";
      });
      fulfillment_radios.forEach((radio) => {
        radio.checked = false;
      });
      // - reset all add-ons to 0
      add_on_inputs.forEach((input) => {
        input.value = 0;
      });
      // remove item as added to order
      item.classList.remove("item-in-order");
      // - close pop up
      close_selection_pop_up(item, {
        msg: "Item removed from order!",
        type: "warning",
        time: 4000,
      });
    }

    function revert_order_to_open_state(specific_item, starting_state) {
      // Get item elements
      const { size_radios,size_selects, add_on_inputs, fulfillment_radios } =
        get_item_elements(specific_item);

      // loop through all inputs
      [...size_radios,...size_selects, ...add_on_inputs, ...fulfillment_radios].forEach(
        (input, i) => {
          // get input element
          const input_element = document.getElementById(input.id);
          // get matching starting state input and revert value and checked to match
          input_element.checked = starting_state[i].checked;
          input_element.value = starting_state[i].value;
        }
      );

      setFlash("Order details reverted!", "warning", 4000);

      close_selection_pop_up(specific_item, {
        msg: "Item updated cancelled and reverted!",
        type: "warning",
        time: 4000,
      });
    }

    // Loop through each .weekly-menu__item
    menu_items.forEach((item) => {
      // check if sold out
      if (item.classList.contains("sold-out")) {
        // if sold out, return and skip all functionality
        return;
      }

      // Select key elements
      const {
        button_open,
        button_confirm,
        button_cancel,
        button_revert,
        click_to_close,
      } = get_item_elements(item);

      // Set up item input state
      let item_state = get_input_states(item);

      // Open item selection pop up
      button_open &&
        button_open.addEventListener("click", () => {
          open_selection_pop_up(item);

          item_state = get_input_states(item);
        });

      // Confirm & Update Add Item to Order
      button_confirm &&
        button_confirm.addEventListener("click", () => add_item_to_order(item));

      // Cancel & Remove Add Item to Order
      button_cancel &&
        button_cancel.addEventListener("click", () =>
          cancel_add_to_order(item)
        );

      // Revert Order to state when opened
      button_revert &&
        button_revert.addEventListener("click", () =>
          revert_order_to_open_state(item, item_state)
        );

      // Click out close
      click_to_close.addEventListener("click", () =>
        revert_order_to_open_state(item, item_state)
      );
      // Escape close
      window.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && item.classList.contains("open")) {
          revert_order_to_open_state(item, item_state);
        }
      });
    });

    // Check if at least one meal has been selected
    // function check_if_meal_selected(e) {
    //   let meal_selected = false;

    //   // loop through each item
    //   menu_items.forEach((item) => {
    //     // loop through each size radio
    //     const { size_radios } = get_item_elements(item);
    //     size_radios.forEach((radio) => {
    //       // check if a size has been selected
    //       if (radio.checked) {
    //         // if so, mark meal_selected = true
    //         meal_selected = true;
    //       }
    //     });
    //   });

    //   // - If not, set error flash and stop form from submitting.
    //   if (!meal_selected) {
    //     e.preventDefault();
    //     setFlash("You must select at least one meal!", "warning");
    //   }
    // }

    // Handle submission of form including confirming an item is selected
    // and marking the user as a returning customer once submitted
    function handleSubmit(e) {
      // Check if at least one meal has been selected
      let meal_selected = false;

      // loop through each item
      menu_items.forEach((item) => {

        // loop through each size radio
        /*const { size_radios } = get_item_elements(item);
        size_radios.forEach((radio) => {
          // check if a size has been selected
          if (radio.checked) {
            // if so, mark meal_selected = true
            meal_selected = true;
          }
        });*/

        // loop through each meal size selects
        const { size_selects } = get_item_elements(item);
        size_selects.forEach((select) => {
          // check if a size has been selected
          if (select.value !== "None") {
            // if so, mark meal_selected = true
            meal_selected = true;
          }
        });
      });

      // - If not, set error flash and stop form from submitting.
      if (!meal_selected) {
        e.preventDefault();
        setFlash("You must select at least one meal!", "warning");
        return;
      }

      const confirmed_customer = e.currentTarget.accountConfirm;

      if (!confirmed_customer.checked) {
        e.preventDefault();
        setFlash(
          "You must confirm you have an account with Red Apron",
          "warning",
          6000
        );
        confirmed_customer.focus();
      } else {
        localStorage.setItem("redApronUser", true);
      }
    }

    const menu_form = menu.querySelector("form.weekly-menu__form");

    menu_form && menu_form.addEventListener("submit", handleSubmit);
  }

  const weeklyMenu = document.querySelector(".weekly-menu");

  weeklyMenu && WeeklyMenu(weeklyMenu);
}
